import diveRemoteConfig from './DiveProvider';
import { DiveSDK } from '../../../../web/node_modules/@divegames/dive-ts-web-sdk';

var diveFeatureFlagsProvider = function diveFeatureFlagsProvider(playerId, handlerCallback) {
  return diveRemoteConfig(playerId, handlerCallback, DiveSDK);
};

export default diveFeatureFlagsProvider;